/**
 * Discount a price represents against its baseline, as a positive percentage.
 *
 * Returns null when there is nothing meaningful to show — a missing price, or a baseline of zero
 * or less, which would otherwise divide by zero or report a nonsensical percentage.
 */
export const discountPercentFromBaseline = (
  price: number | null | undefined,
  baseline: number | null | undefined,
): number | null => {
  if (price == null || baseline == null || baseline <= 0) return null;

  return ((baseline - price) / baseline) * 100;
};
